import React, { FC } from "react";

import { Image, IImageProps } from "../../Utility/MediaBuilder/Image";
import { ILink, Link } from "../../ActionsSelectors/Link";

export interface IBannerProps extends ILink, IImageProps {
  title?: string;
  description?: string;
  customImage?: JSX.Element;
}

const Banner: FC<IBannerProps> = (props) => {
  const { src, alt, title, description, customImage, ...linkProps } = props;

  return (
    <Link {...linkProps} classes={{ root: "banner banner--nav" }}>
      <>
        <div className="banner__img">
          <div>{customImage ?? <Image src={src} alt={alt} />}</div>
        </div>
        <div className="banner__title">{title}</div>
        <div className="banner__desc">{description}</div>
      </>
    </Link>
  );
};

export default Banner;
